module.exports = __webpack_public_path__ + "58f894f71b5c2fb20fc6e520c0bc6eda.png";